import { Destination } from 'types/stream';
import { DestinationKind } from 'types/stream';

const PUBLIC_STATUS = 'Public';
const FRIENDS_STATUS = 'Friends';

type OptionalDestinationKind = DestinationKind | null;

type GetDestinationInfoProps = {
  title: string;
  kind?: OptionalDestinationKind;
  network?: Destination;
};

const getDestinationInfo = ({ kind, title, network }: GetDestinationInfoProps) => {
  if (network === 'RTMP') {
    return kind == 'AmazonLive' ? 'Amazon Live' : 'Custom RTMP';
  }

  const status = kind === 'profile' ? FRIENDS_STATUS : PUBLIC_STATUS;

  return `${title} - ${status}`;
};

export default getDestinationInfo;
